import { Component, OnInit, OnDestroy } from '@angular/core';
import { UtilService } from './shared/helper/util.service';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { HomePageService } from './shared/services/homepage.service';
import { AuthenticateService } from './shared/services/authenticate.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { filter } from 'rxjs/operators';
import { fromEvent } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  isLocalStorage: boolean = false;
  userName: any;
  private lastVisitedUrl: string = '';
  response: any;
  image: any;
  moduleBytesMap: any;
  errMsg: string = '';
  showErrorMessageWithPopup: boolean;
  isUserLoggedIn: boolean = true;

  isAnalyticsHomePage = false;
  popstateSubscription: any;
  isRouteVisible: boolean = true;

  constructor(
    public auth: AuthService,
    private homePageService: HomePageService,
    public router: Router,
    private utilService: UtilService,
    private http: HttpClient,
    private authenticateService: AuthenticateService,
    private spinnerService: NgxSpinnerService,
  ) {
    this.auth.getAccessTokenSilently().subscribe((res: any) => {
      localStorage.setItem('token', res);
    });
  }

  ngOnInit(): void {
    this.spinnerService.show();
    this.showErrorMessageWithPopup = false;
    this.errMsg = '';
    this.isUserLoggedIn = true;    

    this.auth.user$.subscribe((user) => {
      localStorage.setItem('id', user?.sub);
      this.userName = user?.name;

      if (localStorage.getItem('id') == 'undefined') {
        localStorage.setItem('userId', 'undefined');

        if ((this.router.url.split('/')[1] != 'confirm-email' && this.router.url.split('/')[1] != 'create-password' && this.router.url.split('/')[1] != 'forgot-password' && this.router.url.split('/')[1] != 'login')) {      

          this.utilService.isLoggedIn.subscribe(isLogin => {
            if (!isLogin && localStorage.getItem('isLoginInProgress') != 'true') {
              this.lastVisitedUrl = '/login';
              localStorage.setItem('lastVisitedUrl', this.lastVisitedUrl);
            } else if (!isLogin && localStorage.getItem('isLoginInProgress') == 'true'
              && localStorage.getItem('token') != 'undefined'
              && (localStorage.getItem('userType') != null && localStorage.getItem('userType') != 'undefined')) {
              this.lastVisitedUrl = '/login';
              localStorage.setItem('lastVisitedUrl', this.lastVisitedUrl);
              localStorage.setItem('isLoginInProgress', 'false');
            }

            this.isUserLoggedIn = true;
            this.router.navigateByUrl(localStorage.getItem('lastVisitedUrl'));
          });
        } else {
          this.isUserLoggedIn = true;
          this.router.navigateByUrl(localStorage.getItem('lastVisitedUrl'));
        }

      } else {
        this.isUserLoggedIn = true;
        localStorage.setItem('isLoginInProgress', 'true');
        if (localStorage.getItem('lastVisitedUrl') == '/login') {
          this.lastVisitedUrl = '/home';
          localStorage.setItem('lastVisitedUrl', this.lastVisitedUrl);
        }

        this.router.navigateByUrl(localStorage.getItem('lastVisitedUrl'));
      }


      if (localStorage.getItem('id') != 'undefined') {
        this.homePageService.getUserByAuthId().subscribe(
          (res: any) => {
            const response = res;
            const result = response.result;
            const id = result?.id;
            const userType = result?.userType;
            const userStatus = result?.statusName;
            if (userStatus == 'UNVALIDATED')
              this.errMsg = 'User not validated and yet to complete the Onboarding';
            else if (userStatus == 'DELETED' || userStatus == 'INACTIVE')
              this.errMsg = 'User is not Registered on the Platform';

            if (this.errMsg != '') {
              this.showErrorMessageWithPopup = true;
            }

            if (this.errMsg == '') {
              localStorage.setItem('userId', id);
              localStorage.setItem('userType', userType);
              localStorage.setItem('userName', result?.firstName+' '+result?.lastName);
              this.utilService.setUserCompanyName(result?.companyName);
              this.utilService.setUserCompanyId(result?.companyId);
              this.spinnerService.hide();
              this.utilService.userId(id);
              if (localStorage.getItem('userId') != 'undefined') {
                this.lastVisitedUrl = localStorage.getItem('lastVisitedUrl');
                this.router.navigateByUrl(this.lastVisitedUrl);
              }
            }
          },
          (err: any) => {
            console.log('Error :' + err);
          }
        );
      }
    });

    this.http
      .get<Blob>(`${environment.apiUrl}/v1/downloadAllImages`)
      .subscribe((res) => {
        this.response = res;
        this.moduleBytesMap = this.response.result as Object;
        this.utilService.setModuleByte(this.moduleBytesMap);
      });

    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isAnalyticsHomePage = event.urlAfterRedirects.includes('/analytics') || event.urlAfterRedirects.includes('/all-analytics') || event.urlAfterRedirects.includes('/view-details') || event.urlAfterRedirects.includes('/data-products') || event.urlAfterRedirects.includes('/app') || event.urlAfterRedirects.includes('/create-password') || event.urlAfterRedirects.includes('/confirm-email') || event.urlAfterRedirects.includes('/forgot-password') || event.urlAfterRedirects.includes('/confirm-email') || event.urlAfterRedirects.includes('/forgot-password') || event.urlAfterRedirects.includes('/login') || event.urlAfterRedirects.includes('/manage-requests') || event.urlAfterRedirects.includes('module');
    });
  }


  isAnalyticsHomePageFn(): boolean {
    return this.isAnalyticsHomePage;
  }

  onCloseHandler(): void {
    this.errMsg = '';
    this.showErrorMessageWithPopup = false;
    localStorage.clear();
    sessionStorage.clear();
    
    // Navigate to login first to clear the history stack
    this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
      // Then perform Auth0 logout
      this.auth.logout({
        logoutParams: {
          returnTo: `${window.location.origin}`
        }
      });
    });
  }

  ngOnDestroy(): void {
    //---Unsubscribe to popstate event to prevent memory leaks
    if (this.popstateSubscription) {
      this.popstateSubscription.unsubscribe();
    }
  }

}
